<template>
	<Layout class="Layout">
		<Header class="header">
			<it-header ></it-header>
		</Header>
		<Layout>
			<Content class="content">
                <div class="test">
                    <file-list></file-list>
                </div>
			</Content>
		</Layout>
	</Layout>
</template>

<script>
import ItHeader from '../components/Header/ItHeader'
import ItSider from '../components/Sider/ItSider'
import ItBread from '../components/Bread/ItBread'
// import ClassicCaseList from "../components/ClassicCase/ClassicCaseList"
import FileList from "../components/File/FileList"
	export default {
		data(){
			return{
				menu:0,
				isCollapsed:false
			}
		},
		components:{
			ItHeader,
			ItSider,
            ItBread,
            FileList
		}
	}
</script>

<style lang="scss" scoped>
	.header{
		background: rgb(45, 140, 240);
        padding: 0 10px;
	}
	.sider{
		width: 300px;
	}
	.Layout{
		width: 100%;
		height: 100%;
	}
	.content{
		width: 100%;
		background: white;
		.test{
			width: 1300px;
            margin: 0 auto;
		}
	}
</style>




// WEBPACK FOOTER //
// src/page/File.vue